// removed by extract-text-webpack-plugin
module.exports = {"SideNavContainer":"SideNavItem__SideNavContainer__hu_Md","SideNavItem":"SideNavItem__SideNavItem__3dnAP","Active":"SideNavItem__Active__1u6fM"};


//////////////////
// WEBPACK FOOTER
// ./client/src/components/Navigation/SideNavItems/SideNavItem/SideNavItem.css
// module id = 362
// module chunks = 0